import { Routes, Route } from "react-router-dom";

// MSAL imports
import { IPublicClientApplication } from "@azure/msal-browser";

// Router imports
import { PremiumMarketRouter } from "./routers/PremiumMarketRouter";
import { LegacyMarketRouter } from "./routers/LegacyMarketRouter";
import { LandingPage } from "./pages/LandingPage";

type AppProps = {
    premiumPca: IPublicClientApplication;
    legacyPca: IPublicClientApplication;
};

function App({ premiumPca, legacyPca }: AppProps) {
    return (
        <Routes>
            <Route path="/premium-market/*" element={<PremiumMarketRouter pca={premiumPca} />} />
            <Route path="/legacy-market/*" element={<LegacyMarketRouter pca={legacyPca} />} />
            <Route path="/" element={<LandingPage />} />
        </Routes>
    );
}

export default App;